import { ROUTES } from "@repo/core/routes";
import { TokenDataType } from "@repo/core/services/entities/User";
import { hasLayoutBandeirasProduct } from "@repo/core/utils/layoutBandeiras.utils";

import { getSingleValue, hasMultipleValues, hasNoValues } from "./utils";

export type AfterProductNavigation = {
  route: string;
  strPontoAtendimento?: string;
};

export const hasSelectedDifferentProduct = (
  currentProductId: string | undefined,
  selectedProductId: string
): boolean => {
  const normalizedCurrentProductId = currentProductId?.trim();

  return (
    !!normalizedCurrentProductId &&
    normalizedCurrentProductId !== selectedProductId.trim()
  );
};

export const getPreProposalRouteWhenProductMissing = () =>
  ROUTES.preProposalsSelectProduct;

export const shouldRedirectToProductSelection = (
  strProduto?: string | null
) => !hasLayoutBandeirasProduct(strProduto);

export const getNextRouteAfterProductSelection = (
  tokenData: Pick<TokenDataType, "lstPontosAtendimento"> | undefined
): AfterProductNavigation => {
  const lstPontosAtendimento = tokenData?.lstPontosAtendimento;

  if (
    hasNoValues(lstPontosAtendimento) ||
    hasMultipleValues(lstPontosAtendimento)
  ) {
    return { route: ROUTES.preProposalsSelectServicePoint };
  }

  return {
    route: ROUTES.preProposalsSelectAttendant,
    strPontoAtendimento: getSingleValue(lstPontosAtendimento)
  };
};
